'use strict'

module.exports = {
  LOCAL : 1,
  TOLL_FREE : 2,
  SIP : 3,
};
